module.exports = __webpack_public_path__ + "img/psychomotricien-h.ce94ca54.jpg";